module.exports = __webpack_public_path__ + "static/img/step-0.29d66ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/img/tuto-unlock-popup/safari/step-0.png
// module id = L+4s
// module chunks = 1